<template>
  <a-layout>
    <a-layout-sider
      class="vd-gl-sidebar"
      v-model="collapsed"
      :trigger="null"
      collapsible="collapsible"
    >
      <!-- LOGO -->
      <div class="logo" @click="jump('/')">
        <img v-if="collapsed" :src="logo_small" alt="" />
        <img v-else :src="logo_big" alt="" />
      </div>

      <a-menu
        theme="dark"
        mode="inline"
        @click="menuClick"
        @openChange="onOpenChange"
        :openKeys="openKeysArr"
        :selectedKeys="nowOpen"
      >
        <template v-for="item in MenuLists">
          <a-menu-item v-if="!item.children" :key="item.path">
            <a-icon :type="item.icon" />
            <span> {{ item.name }} </span>
          </a-menu-item>
          <!-- 递归组件 -->
          <sub-menu v-else :key="item.path" :menu-info="item"></sub-menu>
        </template>
      </a-menu>
      <!-- 其他 -->

      <a-divider style="color: white;font-size: 13px">其他</a-divider>

      <a-menu theme="dark" mode="inline" :selectable="false">
        <a-menu-item
          v-if="$AuthUtil.authRoute('/suggest')"
          @click="jump('/suggest')"
        >
          <a-icon type="message" />
          <span>意见收集</span>
        </a-menu-item>

        <a-menu-item v-if="$AuthUtil.authRoute('/tool')" @click="jump('/tool')">
          <a-icon type="setting" />
          <span>小功能</span>
        </a-menu-item>

        <a-menu-item @click="jump('/log')">
          <a-icon type="book" />
          <span>平台文档</span>
        </a-menu-item>
        <a-menu-item>
          {{ APP_VERSION }}
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <!-- 右侧布局 -->
    <a-layout>
      <!-- 头部标签 -->
      <a-layout-header class="vd-gl-header">
        <div class="header-bar">
          <div class="header-icon">
            <a-icon
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
          </div>

          <div style="flex: 1 1 0%"></div>
          <div class="vd-layout-flex">
            <a-dropdown class="vd-drop" placement="bottomCenter">
              <div>
                <a-avatar
                  style="margin-right:10px"
                  size="small"
                  icon="user"
                  :src="defaultAvatar"
                />
                <span>{{ userInfo.nickname }} </span>
              </div>
              <a-menu slot="overlay">
                <a-menu-item
                  key="/admin_center/base"
                  @click="jump('/admin_center/base')"
                >
                  <a-icon type="user" />
                  <span>个人中心</span>
                </a-menu-item>
                <a-menu-item
                  key="/admin_setting/base"
                  @click="jump('/admin_setting/base')"
                >
                  <a-icon type="setting" />
                  <span>个人设置</span>
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item key="3" @click="logout()">
                  <a-icon type="logout" />
                  <span>退出登陆</span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
      </a-layout-header>
      <!-- 页面加载 -->
      <template v-if="this.$route.path === '/'">
        <home-page />
      </template>
      <template v-else>
        <work-area />
        <router-view />
      </template>
    </a-layout>
  </a-layout>
</template>
<script>
import { Menu } from 'ant-design-vue'
import logo_big from '@/assets/logo_big.png'
import logo_small from '@/assets/logo_small.png'
import defaultAvatar from '@/assets/default.jpg'
import store from '@/store'
import WorkArea from '@/components/workArea'
import HomePage from '@/components/homePage'
// 自定义组件 递归生成路由
const CustomSubMenu = {
  template: `
      <a-sub-menu :key="menuInfo.path" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <a-icon :type="menuInfo.icon"/>
          <span>{{ menuInfo.name }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="!item.children" :key="item.path">
            <a-icon :type="item.icon"/>
            <span>{{ item.name }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.path" :menu-info="item"/>
        </template>
      </a-sub-menu>
    `,
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
}

export default {
  components: {
    'sub-menu': CustomSubMenu,
    'work-area': WorkArea,
    'home-page': HomePage,
  },
  name: 'Layout',
  data() {
    let upload_url = this.UPLOAD_URL

    return {
      upload_url,
      logo_big,
      defaultAvatar,
      logo_small,
      collapsed: false,
      nowOpen: [],
      openKeysArr: [],
      openKeys: [],
      rootSubmenuKeys: [],
      userInfo: {
        nickname: 'xxx',
        username: 'xxxx',
      },
      is_complete: false,
      visible: false,
      form: {
        content: '',
      },
      fileList: [],
    }
  },
  created() {
    const openKeys = localStorage.getItem('openKeys')
    this.userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
    this.is_complete = JSON.parse(localStorage.getItem('IS_COMPLETE'))
    if (openKeys) {
      this.openKeys = JSON.parse(openKeys)
    }
    this.rootSubmenuKeys = store.getters.ROLES
    localStorage.setItem('APP_VERSION', this.APP_VERSION)
  },
  methods: {
    menuClick({ key, keyPath }) {
      this.nowOpen = [key]
      this.jump(key)
      this.openKeysArr = keyPath
    },
    jump(key) {
      this.$router.push({ path: key, replace: false })
    },
    onOpenChange(openKeys) {
      this.openKeysArr = openKeys
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      )
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
      // 将当前打开的父级菜单存入缓存中
      localStorage.setItem('openKeys', JSON.stringify(this.openKeys))
    },
    // 登出操作
    logout() {
      // 加提示
      this.$confirm({
        title: '退出',
        content: '确定退出?',
        okText: '确认退出',
        cancelText: '取消',
        onOk: () => {
          // 清空缓存
          store.commit('SET_MENUS', [])
          store.commit('SET_ROLES', [])
          store.commit('SET_USER_INFO', {})
          localStorage.clear()
          this.$router.push({ path: '/user/login', replace: true })
        },
      })
    },
    findRouterPath(path, arr) {
      for (const item of arr) {
        let pathArr = []
        pathArr.push(item.path)
        if (item.path === path) {
          return pathArr
        }
        if (item.children && item.children.length) {
          const _item = this.findRouterPath(path, item.children)
          if (_item) {
            pathArr.push(_item)
            return pathArr
          }
        }
      }
    },
  },
  computed: {
    MenuLists: () => store.getters.Menus,
  },
  watch: {
    $route: {
      handler(val) {
        this.nowOpen = [val.path]
        let list = this.findRouterPath(val.path, this.MenuLists)
        if (list) {
          let arr = [].concat(...list)
          this.openKeysArr = arr
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
}
</script>
<style scoped>
.header-bar {
  width: 100%;
  display: flex;
  padding: 0px 16px;
  line-height: 48px;
}
.header-icon {
  display: flex;
  align-items: center;
  justify-items: center;
  font-size: 18px;
  margin-left: 8px;
}

.trigger {
  font-size: 18px;
  height: inherit;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.trigger:hover {
  color: #1890ff;
  background: rgba(0, 0, 0, 0.025);
}

.vd-layout-flex {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-right: 16px;
}

.logo {
  height: 32px;
  margin: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.vd-drop {
  display: flex;
  height: 48px;
  align-items: center;
}

.vd-header:hover {
  background: rgba(0, 0, 0, 0.025);
}
</style>
